import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconChevronTop, IconChevronBottom } from '@travel-frontend/icons';
import { useState } from 'react';
import { Arrow } from '../../../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/Category/components/Arrow.js';
import { Badge } from '../../../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/Category/components/Badge.js';
import { Body } from '../../../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/Category/components/Body.js';
import { Container } from '../../../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/Category/components/Container.js';
import { Head } from '../../../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/Category/components/Head.js';
import { Title } from '../../../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/RelevantNow/components/Category/components/Title.js';
export const Category = ({
  title,
  badge,
  children
}) => {
  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapsed = () => setCollapsed(previous => !previous);
  return _jsxs(Container, {
    children: [_jsxs(Head, {
      tabIndex: 0,
      onClick: toggleCollapsed,
      children: [_jsx(Title, {
        children: title
      }), _jsx(Badge, {
        children: badge
      }), _jsx(Arrow, {
        children: collapsed ? _jsx(IconChevronBottom, {}) : _jsx(IconChevronTop, {})
      })]
    }), !collapsed && _jsx(Body, {
      children: children
    })]
  });
};